import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Button from '../../lib/ui/buttons/Button';
import InputField from '../../lib/ui/inputs/Input';
import DropDown from "../../lib/ui/dropdown/Dropdown";
import Radio from '../../lib/ui/radio/Radio';
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import LogoBranding from '../../lib/ui/logoBranding/LogoBranding';
import { LangCtx, CustomCtx } from "../../lib/context";
import { langObj } from "../../locale/index";
import 'react-phone-number-input/style.css';
import '../../lib/ui/imageicon/Styles.css';
import '../../lib/ui/inputs/InputStyles.css';
import "../../layouts/Layouts.css";
import "../../ui-styles/picker/picker.css";
import '../../ui-styles/iconButtons/iconButton.css';
import DateFnsUtils from '@date-io/date-fns';
import titlesList from "../../config/titles.json";
import statesList from "../../config/states.json";
import citiesList from "../../config/cities.json";
// import titlesList from "../../config/titles.json";
import countriesList from "../../config/countries.json";
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { validateDate, validateEmail, validateLetters, validatePassword } from "../../lib/validation"

import { patientsignup } from "../../actions/users";
import AddrDropDown from '../../lib/ui/dropdown/addressDropDown';
import { Auth, API } from "aws-amplify";
import Loader from "../../lib/ui/loader/Loader";
import bloodgroups from "../../config/bloodgroup.json";
import { getSubdomain } from '../../lib/domain';
// const psl = require('psl');

//const titlesList = [{value: "", label:"Select"},{ value: "Mr", label: "Mr." }, { value: "Mrs", label: "Mrs." }, { value: "Ms", label: "Ms." }, { value: "Master", label: "Master" }, { value: "Miss", label: "Miss" }]
const SignupPage = (props) => {
    const { l, setLang } = useContext(LangCtx);
    const { custom } = useContext(CustomCtx);
    const history = useHistory();

    const [gender, setGender] = React.useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [error, setError] = useState({});
    const [firstName, setfirstName] = useState('');
    const [lastName, setLastName] = useState('');
    //    const [civilNumber, setCivilNumber] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [dob, setDob] = useState(new Date().valueOf());
    const [bloodgroup, setBloodgruop] = useState('');
    const [states, setStates] = useState([{
        value: "",
        label: l.select_state
    },]);
    const [cities, setCities] = useState([{
        value: "",
        label: l.select_city
    },]);
    const [address, setAddress] = useState('');
    const [country, setCountry] = useState('India');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [title, setTitle] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    // const _domain = psl.parse(window.location.hostname);
    const _domain = getSubdomain(window.location.hostname);

    const langOptions = [{ value: "en", label: l.english }, { value: "hi", label: l.hindi },{ value: "fr", label: l.french }]

    const handleLang = (e) => {
        setLang(langObj[e.target.value]);
        localStorage.setItem('lang', e.target.value);
    }

    useEffect(() => {
        let _statesList = statesList.filter((state) => state.countryid === country);
        _statesList.unshift({
            value: "",
            label: l.select_state
        });
        _statesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
        setStates([..._statesList]);
        setCity(''); 
        setCities([{ value: "", label: l.select_city }]);
    }, [country]);

    useEffect(() => {
        let _citiesList = citiesList.filter((city) => city.stateid === state);
        if (_citiesList.length === 0) {
            _citiesList = [{
                value: "",
                label: l.no_cities_available
            }];
        } else {
            _citiesList.unshift({
                value: "",
                label: l.select_city
            });
        }
        _citiesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
        setCities(_citiesList);
    }, [state]);

    const validate = () => {
        let _error = {};
        let returnValue = true;

        if (title === '' || title == null) {
            _error['title'] = l.pls_ent_title
            returnValue = false
        }
        if (firstName === '' || firstName == null) {
            _error['firstName'] = l.pls_ent_fName
            returnValue = false
        }
        else if (!validateLetters(firstName)) {
            _error['firstName'] = l.pls_ent_letters_fName
            returnValue = false;
        }
        if (lastName === '' || lastName == null) {
            _error['lastName'] = l.pls_ent_lName
            returnValue = false
        }
        else if (!validateLetters(lastName)) {
            _error['lastName'] = l.pls_ent_letters_lName
            returnValue = false;
        }
        if (email === '' || email == null) {
            _error['email'] = l.pls_enter_email
            returnValue = false
        }
        else if (!validateEmail(email)) {
            _error['email'] = l.pls_check_email
            returnValue = false
        }
        if (phone === '' || phone == null) {
            _error['phone'] = l.pls_enter_phone
            returnValue = false
        }
        else if (!isValidPhoneNumber(phone)) {
            _error['phone'] = l.pls_check_phone
            returnValue = false
        }
        if (gender === '' || gender == null) {
            _error['gender'] = l.pls_sel_gender
            returnValue = false
        }
        if (dob === '' || dob == null) {
            _error['dob'] = l.pls_sel_dob
            returnValue = false
        }
        else if (!validateDate(dob)) {
            _error['dob'] = l.pls_check_dob
            returnValue = false
        }
        if (bloodgroup === '' || bloodgroup == null) {
            _error['bloodgroup'] = l.pls_sel_bldgp
            returnValue = false
        }
        // if (address === '' || address == null) {
        //     _error['address'] = l.pls_sel_dob
        //     returnValue = false
        // }
        if (country === '' || country == null) {
            _error['country'] = l.pls_sel_country
            returnValue = false
        }
        if (state === '' || state == null) {
            _error['state'] = l.pls_sel_state
            returnValue = false
        }
        if (city === '' || city == null) {
            _error['city'] = l.pls_sel_city
            returnValue = false
        }
        if (password === '') {
            _error['password'] = l.pls_ent_new_pwd
            returnValue = false
        }
        else if (!validatePassword(password)) {
            _error['password'] = l.ent_valid_pwd
            returnValue = false
        }

        setError(_error);
        return returnValue;

    }

    const handleSignupBtn = async e => {
        e.preventDefault();
        try {
            if (validate()) {
                setErrorMsg('');
                setLoading(true);
                const phoneNumber = parsePhoneNumber(phone)
                const countrycode = phoneNumber.countryCallingCode;
                const number = phoneNumber.nationalNumber;
                let body = {
                    title:title,
                    firstName: firstName.trim(),
                    lastName: lastName.trim(),
                    email: email.trim(),
                    //        civilNumber: civilNumber.trim(),
                    countryCode: countrycode,
                    phone: number.trim(),
                    gender: gender.trim(),
                    bloodgroup:bloodgroup,
                    dob: dob.valueOf(),
                    address: address,
                    country: country,
                    stateName: state,
                    city: city,
                    password: password,
                    assignedTo: custom.defaultClinicId,
                    clinicId: custom.defaultClinicId,
                    domain: _domain && _domain.subdomain ? _domain.subdomain : custom.subDomain
                    // domain: 'inclinix'
                    // adminId: config.defaultClinicAdminId
                }
                if (process.env.REACT_APP_isOffline === "true") {
                    patientsignup(body)
                        .then(res => {
                            history.push('/')
                            // history.push('/verify-account?phone=' + phone.trim());
                        })
                        .catch(err => {
                            let msg = err?.response?.data ? err.response.data.error : l.unable_upd_patient;
                            setErrorMsg(msg);
                            setLoading(false);
                        });
                } else {
                    if (custom.defaultClinicId && custom.defaultClinicId !== null) {
                        const cognito_body = {
                            name: firstName.trim() + ' ' + lastName.trim(),
                            'custom:title':title.trim(),
                            'custom:fname': firstName.trim(),
                            'custom:lname': lastName.trim(),
                            'custom:email': email.trim(),
                            'custom:phone': phone.trim(),
                            'custom:gender': gender.trim(),
                            'custom:dob': dob.valueOf().toString(),
                            phone_number: phone.trim(),
                            // 'custom:Street': division,
                            address:address,
                            'custom:State': state ? state : '',
                            'custom:District': city,
                            'custom:Country': country,
                            'custom:consult_assignedTo': custom.defaultClinicId,
                            'custom:clinicId': custom.defaultClinicId,
                            // 'custom:adminId': config.defaultClinicAdminId,
                            'custom:consultRole': "patient",
                            "custom:domain": _domain && _domain.subdomain ? _domain.subdomain : custom.subDomain
                            // "custom:domain": 'inclinix'
                        }
                        const newUser = await Auth.signUp({
                            username: phone.trim(),
                            password: password,
                            attributes: cognito_body,
                        });

                        if (newUser.userSub) {
                            body['userSub'] = newUser.userSub;
                            API.post("users", "/createuser", { body })
                                .then(res => {
                                    // return dispatch(setProfile(res.data));
                                    history.push('/verify-account?phone=' + phone.trim());
                                })
                                .catch(err => {
                                    console.log("err in getProfile ", err.message);
                                    let msg = err?.response?.data?.error ? err.response.data.error : l.unable_upd_patient;
                                    setErrorMsg(msg);
                                    setLoading(false);
                                });
                        }
                    } else {
                        setErrorMsg("Please contact Admin");
                        setLoading(false);
                    }
                }

            }
            else {
                if (errorMsg != null) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }
            }
        } catch (err) {
            console.log("Error", err);
            let msg = err && err.message ? err.message : l.unable_upd_patient;
            setErrorMsg(msg);
            setLoading(false);
        }

    }


    return <Fragment>
        <div className="coverContainer">
            <div className="outSideContainer">
                <div className="colCredential">
                    <div className="topRow">
                        <div className="langBlock">
                            <DropDown placeholder="Languages" items={langOptions} value={localStorage.getItem('lang') ? localStorage.getItem('lang') : l.locale} onChange={handleLang} />
                        </div>
                    </div>
                    {loading && <Loader />}
                    <div className="bodyRow">
                        <div className="brandingBlock">
                            <LogoBranding />
                        </div>
                        <div className="crdFormBlock">
                            <div className="crdHeadingBlock justifyCenter">
                                <h2 className="headingTxt">{l.signup}</h2>
                            </div>

                            {errorMsg && errorMsg !== "" && <div className="errorBox">
                                <small className="errorTxt">{errorMsg}</small>
                            </div>
                            }

                            <div className="colBlock mrgTop16">
                                <form id="forgotform" >
                                    <Link to ="/clinic-signup" className="iconBtnFilled md ripple fullWidth" >
                                        <img src="/images/icons/clinic-white.png" alt="icon" />
                                        <div className="brdr"></div>
                                        <span className="mrgLeft8">{l.clinic_signup}</span>
                                    </Link>
                                    <div className="txtCenter pdngTB16">
                                        <p>OR</p>
                                    </div>
                                    <Link to ="/patient-signup" className="iconBtnFilled md ripple fullWidth" >
                                        <img src="/images/icons/patient-white.png" alt="icon" />
                                        <div className="brdr"></div>
                                        <span className="mrgLeft8">{l.sign_as_patient}</span>
                                    </Link>
                                </form>

                            {false &&
                            <div>
                                <div className="rowBlock">
                                    <div className="inputRowGroup flex0 mrgRight8">
                                        <small className="inpLabel">{l.label_title}<span className="redTxt">*</span>:</small>
                                        <AddrDropDown
                                            placeholder={l.select_title}
                                            items={titlesList}
                                            value={title}
                                            error={error && error.title}
                                            errorMsg={error.title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </div>
                                    <div className="inputRowGroup mrgRight8">
                                        <small className="inpLabel">{l.inp_fname}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            name="firstName"
                                            placeholder={l.inp_fname}
                                            type="text"
                                            value={firstName}
                                            error={error && error.firstName}
                                            errorMsg={error.firstName}
                                            maxLength="30"
                                            onChange={(e) => setfirstName(e.target.value)}
                                        />
                                    </div>
                                    <div className="inputRowGroup">
                                        <small className="inpLabel">{l.inp_lname}<span className="redTxt">*</span>:</small>
                                        <InputField
                                            placeholder={l.inp_lname}
                                            name="lastName"
                                            type="text"
                                            value={lastName}
                                            error={error && error.lastName}
                                            errorMsg={error.lastName}
                                            maxLength="30"
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="inputBox colBlock nopdng">
                                    <small className="inpLabel">{l.phone_no}<span className="redTxt">*</span>:</small>
                                    <PhoneInput className="customPkgInput"
                                        international
                                        countryCallingCodeEditable={false}
                                        defaultCountry="IN"
                                        maxLength="17"
                                        value={phone}
                                        error={error && error.phone}
                                        errorMsg={error.phone}
                                        onChange={setPhone} />
                                    <label>{props.label}</label>
                                    {(error && error.phone) && <span className="inputErrorMsg">{error.phone}</span>}
                                </div>
                                <small className="inpLabel">{l.email_address}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.email_address}
                                    type="email"
                                    value={email}
                                    maxLength="50"
                                    error={error && error.email}
                                    errorMsg={error.email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />

                                <div className="inputRowFeild">
                                    <small className="inpLabel">{l.label_gender}<span className="redTxt">*</span>:</small>
                                    <div className="hozRadioGroup">
                                        <div className={gender === "male" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                            <Radio id="male" name="gender" label={l.male} value="male" checked={gender === "male" ? true : false} onChange={(e) => setGender(e.target.value)} />
                                            {/* <img className={gender === "M" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/male.png" alt="gendericon" /> */}
                                            {/* <span>{l.male}</span> */}

                                        </div>
                                        <div className={gender === "female" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                            <Radio id="female" name="gender" label={l.female} value="female" checked={gender === "female" ? true : false} onChange={(e) => setGender(e.target.value)} />
                                            {/* <img className={gender === "F" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/female.png" alt="gendericon" /> */}
                                            {/* <span >{l.female}</span> */}
                                        </div>
                                        <div className={gender === "others" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                            <Radio id="others" name="gender" label={l.others} value="others" checked={gender === "others" ? true : false} onChange={(e) => setGender(e.target.value)} />
                                            {/* <span>{l.others}</span> */}
                                        </div>
                                    </div>
                                    {(error && error.gender) && <span className="inputErrorMsg">{error.gender}</span>}
                                </div>
                                <div className="rowBlock alignCenter">
                                    <div className="inputRowGroup mrgRight8">
                                        <small className="inpLabel">{l.dob}<span className="redTxt">*</span>:</small>
                                        <div className="inputBox alignCenter">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker fullWidth
                                                    className="pickerInput"
                                                    inputVariant="outlined"
                                                    value={dob}
                                                    onChange={(date) => setDob(date && date.valueOf())}
                                                    animateYearScrolling
                                                    placeholder={l.dob}
                                                    format="dd/MM/yyyy"
                                                    maxDate={new Date()}
                                                />
                                                {/*<div className="inputIconBox"><img src="/images/icons/date.png" className="invertGray" alt="date"/></div>*/}
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        {(error && error.dob) && <span className="inputErrorMsg">{error.dob}</span>}
                                    </div>
                                    <div className="inputRowGroup ">
                                        <small className="inpLabel">{l.select_bldgrp}<span className="redTxt">*</span>:</small>
                                        <DropDown
                                            placeholder={l.select_bldgrp}
                                            items={bloodgroups}
                                            value={decodeURIComponent(bloodgroup)}
                                            error={error && error.bloodgroup}
                                            errorMsg={error.bloodgroup}
                                            onChange={(e) => setBloodgruop(encodeURIComponent(e.target.value))}
                                        />
                                    </div>
                                </div>

                                <small className="inpLabel">{l.pat_address}:</small>
                                <InputField
                                    placeholder={l.pat_address}
                                    type="text"
                                    value={address}
                                    maxLength="100"
                                    error={error && error.address}
                                    errorMsg={error.address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                                <small className="inpLabel">{l.label_country}:</small>
                                <AddrDropDown
                                    placeholder={l.select_country}
                                    items={countriesList}
                                    value={country}
                                    error={error && error.country}
                                    errorMsg={error.country}
                                    onChange={(e) => setCountry(e.target.value)}
                                />

                                <div className="rowBlock">
                                    <div className="inputRowGroup mrgRight8">
                                        <small className="inpLabel">{l.label_state}<span className="redTxt">*</span>:</small>
                                        <AddrDropDown
                                            placeholder={l.select_state}
                                            items={states}
                                            value={state}
                                            error={error && error.state}
                                            errorMsg={error.state}
                                            onChange={(e) => setState(e.target.value)}
                                        />
                                    </div>
                                    <div className="inputRowGroup">
                                        <small className="inpLabel">{l.label_city}<span className="redTxt">*</span>:</small>
                                        <AddrDropDown
                                            placeholder={l.select_city}
                                            items={cities}
                                            value={city}
                                            error={error && error.city}
                                            errorMsg={error.city}
                                            onChange={(e) => setCity(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <small className="inpLabel">{l.pass}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.pass}
                                    type="password"
                                    value={password}
                                    error={error && error.password}
                                    errorMsg={error.password}
                                    maxLength="30"
                                    onChange={(e) => setPassword(e.target.value)}
                                    showPwd={true}
                                />
                                <span className="smallPTxt">{l.pwd_security}</span>
                                <form id="forgotform" onSubmit={handleSignupBtn}>
                                    <div className="crdBtnContainer">
                                        <Button onClick={handleSignupBtn}
                                            label={l.create_account}
                                            type='primary'
                                            size='md'
                                            fullWidth="fullWidth"
                                        />
                                    </div>
                                </form>
                                <div className="crdRowBlock mrgTop24">
                                    <small className="pTxt blackInactiveTxt txtCenter">{l.terms_msg}
                                        <Link to="/terms-conditions" target="_blank" className="linkTxt linkTxtSm"> {l.terms_cond}</Link> {l.and}
                                        {/* <Link to="/privacy-policy" target="_blank" className="linkTxt linkTxtSm"> {l.privacy_policy}</Link> {l.agreeTxt}. */}
                                    </small>
                                </div>
                                </div>
                            }
                            </div>
                        </div>
                    </div>
                    <div className="footerRow">
                        <div className="rowSpaceBtwn">
                            <p className="pTxt mrgRight8">{l.alrdy_have_acct}</p>
                            <Link to="/" className="linkTxt linkTxtMd">{l.login}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
}

export default SignupPage;